import { get } from '~/utils/adapi';

const SET_DATA = 'SET_DATA';
const SET_LOADING = 'SET_LOADING';
const SET_VISIBILITY = 'SET_VISIBILITY';

const actions = {
  updateFilterData({ commit }, filters) {
    commit(SET_LOADING, true);

    const data = {};

    Promise.all(filters
      .filter(f => f.getData || f.filterData)
      .map(f => {
        if (f.getData) {
          return get(f.getData)
            .then(res => f.formatGetData(res))
            .then(res => data[f.slug] = res);
        } else if (f.filterData) {
          return Promise.resolve(f.filterData)
            .then(res => (f.formatGetData ? f.formatGetData(res) : res))
            .then(res => data[f.slug] = res);
        }

        return Promise.reject(new Error('should never happen'));
      }),
    )
      .then(() => {
        commit(SET_DATA, { data, error: null });
        commit(SET_LOADING, false);
      })
      .catch(error => {
        commit(SET_DATA, { data: null, error });
        commit(SET_LOADING, false);
      });
  },
  setVisibility({ commit }, visible) {
    commit(SET_VISIBILITY, visible);
  },
};

const mutations = {
  [SET_DATA](state, { data, error }) {
    state.data = data;
    state.error = error;
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
  [SET_VISIBILITY](state, visible) {
    state.visible = visible;
  },
};

export default {
  namespaced: true,
  state: {
    data: {},
    error: null,
    loading: false,
    visible: false,
  },
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/store/modules/searchFilters.js